<template>
  <LoadingSpinner :loading="loading"> </LoadingSpinner>

  <div class="container mt-4">
    <div style="max-width:597px">
        <h3>Legg til stengte dager</h3>
        <p class="mt-4">Hvis du vil holde stengt i kun én dag, velger du samme dag på fra-og-med dato og til-og-med dato.</p>

        <div v-if="hasMultiLocations()" class="select-location-box mt-4">
          <span class="ingredient-title">Velg avdeling</span>
          <select class="form-select" v-model="locationId">
            <option v-for="(location, index) in locations" :key="index" :value="location.id">{{ location.name }}</option>
          </select>
        </div>

        <SelectDate ref="selectDateFrom" label="Fra og med dato"/>
        <SelectDate ref="selectDateTo" label="Til og med dato"/>
        <div class="mb-5">
          <span>Informasjon som skal vises til brukere</span>
          <input type='text' id="message" class="form-control" placeholder="F.eks. Vi holder stengt fra 16.juni til 01.juli pga ferie." v-model="message" />
        </div>

        <div :class="createAnnouncement ? 'form-switch-wrapper mt-1 mb-3' : 'form-switch-wrapper mt-0 mb-5'">
          <label class="form-switch">
            <div class="form-switch-container">
              <span class="bold me-2">Vis melding til gjester i forveien</span>
              <input type="checkbox" v-model="createAnnouncement" />
              <i></i>
            </div>
          </label>
        </div>

        <div v-if="createAnnouncement" class="mb-5" style="clear: both;">
          <p class="mt-2 mb-3" style="font-size: 14px; opacity: 0.8;">Velg perioden meldingen skal vises på forsiden i nettbutikken. Samme melding som over blir brukt.</p>
          <SelectDate ref="selectDisplayFromDate" label="Vis fra og med dato"/>
          <SelectDate ref="selectDisplayToDate" label="Vis til og med dato" :selectedDate="displayToDatePreselected"/>
        </div>

        <hr style="clear: both;"/>
        <button v-if="activateSaveButton" type="button" class="bo_btn mb-5" @click="save"> Lagre </button>
        <button v-else type="button" class="bo_btn mb-5" @click="save" disabled="true"> Lagre </button>
      </div>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/other/LoadingSpinner";
import SelectDate from "@/components/other/SelectDate";
import MerchantUtil from "@/util/MerchantUtil";
import SettingsService from "@/services/settings/SettingsService";
import moment from "moment";
import LocationUtil from "@/util/LocationUtil";
import LocationService from "@/services/location/LocationService";

export default {
    components: {LoadingSpinner, SelectDate},
    data() {
      return {
        loading: false,
        locationId: '',
        locations: [],
        message: '',
        createAnnouncement: false,
        displayToDatePreselected: null
      };
    },
    computed: {
      activateSaveButton(){
        if(this.message.length > 0){
          return true;
        } else {
          return false;
        }
      }
    },
    watch: {
      createAnnouncement(newVal) {
        if(newVal && this.$refs.selectDateTo) {
          this.displayToDatePreselected = this.$refs.selectDateTo.getSelectedDate();
        }
      }
    },
    mounted() {
      const query = this.$route.query;
      const prefillFromAnnouncement = query.prefillFromAnnouncement === '1';
      if(prefillFromAnnouncement){
        // Came here from AnnouncementCreate because the message looked like it
        // was about closed days. Pre-fill the form and enable the announcement
        // toggle so the same message is shown to guests in advance.
        this.message = query.message || '';
        this.createAnnouncement = true;
        this.$nextTick(() => {
          if(query.fromDate){
            this.$refs.selectDateFrom.setSelectedDate(query.fromDate);
            if(this.$refs.selectDisplayFromDate) this.$refs.selectDisplayFromDate.setSelectedDate(query.fromDate);
          }
          if(query.toDate){
            this.$refs.selectDateTo.setSelectedDate(query.toDate);
            if(this.$refs.selectDisplayToDate) this.$refs.selectDisplayToDate.setSelectedDate(query.toDate);
          }
        });
      }
      LocationService.listLocations().then(
          (response) => {
            this.locations = response.data;
            if(prefillFromAnnouncement && query.locationId){
              this.locationId = query.locationId;
            } else {
              this.locationId = this.locations.length ? this.locations[0].id : '';
            }
          },
          (error) => {
            console.log(error);
          }
      );
    },
    methods: {
      hasMultiLocations(){
        return LocationUtil.hasMultiLocations();
      },
      save(){
        this.loading = true;

        let fromDate =  this.$refs.selectDateFrom.getSelectedDate();
        let toDate =  this.$refs.selectDateTo.getSelectedDate();
        let closingDays = {
          type: "closingdays",
          merchant: MerchantUtil.getMerchant(),
          locationId: this.locationId,
          fromDate: (moment(fromDate)).format('YYYY-MM-DD'),
          toDate: (moment(toDate)).format('YYYY-MM-DD'),
          message: this.message
        };
        this.createClosingDays(closingDays);
      },
      createClosingDays(closingDays){
        SettingsService.createClosingDays(closingDays).then(
            (response) => {
              let documentId = response.data;
              if(documentId){
                if(this.createAnnouncement){
                  this.saveAnnouncement();
                } else {
                  this.$router.push({ path: 'closingdays' });
                }
              } else {
                console.log("Creating closingDays failed");
                this.loading = false;
              }
            },
            (error) => {
              console.log(error);
              this.loading = false;
            }
        );
      },
      saveAnnouncement(){
        let displayFromDate = this.$refs.selectDisplayFromDate.getSelectedDate();
        let displayToDate = this.$refs.selectDisplayToDate.getSelectedDate();
        let announcement = {
          type: "announcement",
          merchant: MerchantUtil.getMerchant(),
          locationId: this.locationId,
          displayFromDate: (moment(displayFromDate)).format('YYYY-MM-DD'),
          displayToDate: (moment(displayToDate)).format('YYYY-MM-DD'),
          message: this.message
        };
        SettingsService.createAnnouncement(announcement).then(
            (response) => {
              let documentId = response.data;
              if(documentId){
                this.$router.push({ path: 'closingdays' });
              } else {
                console.log("Creating announcement failed");
              }
              this.loading = false;
            },
            (error) => {
              console.log(error);
              this.loading = false;
            }
        );
      }
    }
  };
</script>
